<template>
    <div class="col-md-6 col-sm-6">
        <div class="news-box">
            <div class="news-box-left img-scale-in">
                <a :href="$store.state.hrefPrefix + '/articles/' + article.slug"><img :src="article.blob.url" alt="/"/></a>
            </div>
            <div class="news-box-right">
                <h2><a :href="$store.state.hrefPrefix + '/articles/' + article.slug">{{article.article_languages[0].pivot.title}}</a></h2>
                <span>{{ formattedCreatedAt }}</span>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    name: "MiddleArticle",
    props: {
        article: {
            type: Object,
            default: null
        }
    },
    computed: {
        formattedCreatedAt() {
            const date = new Date((this.article.published_at ?? this.article.created_at).replace(' ', 'T'));
            const options = { month: 'short', day: 'numeric', year: 'numeric' };
            let locale = 'en-US';
            switch (this.$store.state.language.code) {
                case 'ar':
                    locale = 'ar-LB';
                    break;
                case 'tr':
                    locale = 'tr-TR';
                    break;
            }
            return date.toLocaleDateString(locale, options).toUpperCase();
        }
    }
}
</script>

<style scoped>

</style>
